import React from 'react';
import styles from './Location.module.scss';
import LocationIcon from './location-dot-solid.svg';

function Location(props) {
    const { className = '', children, tagName: Tag = 'div', color } = props,
        style = color
            ? {
                  color: `${color}`,
              }
            : null;

    if (!children) return null;

    return (
        <Tag className={className} style={style}>
            <LocationIcon className={styles.icon} style={style} />
            {children}
        </Tag>
    );
}

export default Location;
